import React from 'react';
import { Button } from '../ui';
import './B2BPageShell.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

export function B2BPageFooterAction({
  children,
  className = '',
  leftIcon,
  onClick,
  type = 'button',
  ...props
}) {
  return (
    <Button
      className={cx('b2b-page-shell__footer-button', className)}
      variant="primary"
      size="lg"
      leftIcon={leftIcon}
      onClick={onClick}
      type={type}
      {...props}
    >
      {children}
    </Button>
  );
}

export default function B2BPageShell({
  title,
  description,
  children,
  footer,
  className = '',
  headerClassName = '',
  mainClassName = '',
  contentClassName = '',
  footerClassName = '',
}) {
  return (
    <div className={cx('b2b-page-shell', className)}>
      <header className={cx('b2b-page-shell__header', headerClassName)}>
        <h1>{title}</h1>
        {description ? <p>{description}</p> : null}
      </header>

      <main className={cx('b2b-page-shell__main', mainClassName)}>
        <div className={cx('b2b-page-shell__content', contentClassName)}>
          {children}
        </div>
      </main>

      {footer ? (
        <footer className={cx('b2b-page-shell__footer', footerClassName)}>
          <div className="b2b-page-shell__footer-inner">{footer}</div>
        </footer>
      ) : null}
    </div>
  );
}
